









































































import {
  computed, defineComponent, ref, watch,
} from 'vue';
// import { useRouter } from 'vue-router';

import api from '@/api';
import store from '@/store';
import { useRouter } from 'vue-router/composables';

export default defineComponent({
  setup() {
    const dialog = ref(false);
    const newWorkspace = ref('');
    const error = ref('');

    const userInfo = computed(() => store.state.userInfo);

    watch(dialog, () => {
      if (dialog.value) {
        error.value = '';
      }
    });

    const router = useRouter();
    async function create() {
      if (newWorkspace.value) {
        try {
          const response = await api.createWorkspace(newWorkspace.value);

          if (response) {
            store.dispatch.fetchWorkspaces();

            router.push(`/workspaces/${newWorkspace.value}`);

            newWorkspace.value = '';
            dialog.value = false;
          }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err: any) {
          if (err.status === 409) {
            error.value = `Workspace "${err.data}" already exists!`;
          } else {
            error.value = `Error creating workspace: ${err.status}`;
          }
        }
      }
    }

    return {
      dialog,
      newWorkspace,
      error,
      userInfo,
      create,
    };
  },
});
